"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.cell = void 0;
var cell = {
  height: '35px',
  width: "".concat(100 / 7, "%"),
  textAlign: 'center',
  userSelect: 'none'
};
exports.cell = cell;
var styles = {
  root: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  headerCell: {
    extend: cell,
    fontWeight: 'normal',
    fontSize: '12px'
  }
};
var _default = styles;
exports["default"] = _default;